import {
  VAT_MANAGER_ACTIVE,
  VAT_MANAGER_ACTIVE_FAIL,
  VAT_MANAGER_ACTIVE_RESET,
  VAT_MANAGER_ACTIVE_SUCCESS,
  VAT_MANAGER_CREATE,
  VAT_MANAGER_CREATE_FAIL,
  VAT_MANAGER_CREATE_RESET,
  VAT_MANAGER_CREATE_SUCCESS,
  VAT_MANAGER_DELETE,
  VAT_MANAGER_DELETE_FAIL,
  VAT_MANAGER_DELETE_RESET,
  VAT_MANAGER_DELETE_SUCCESS,
  VAT_MANAGER_DETAIL,
  VAT_MANAGER_DETAIL_FAIL,
  VAT_MANAGER_DETAIL_RESET,
  VAT_MANAGER_DETAIL_SUCCESS,
  VAT_MANAGER_LIST,
  VAT_MANAGER_LIST_COLUMN,
  VAT_MANAGER_LIST_FAIL,
  VAT_MANAGER_LIST_RESET,
  VAT_MANAGER_LIST_SUCCESS,
  VAT_MANAGER_ROLE_LIST,
  VAT_MANAGER_ROLE_LIST_FAIL,
  VAT_MANAGER_ROLE_LIST_RESET,
  VAT_MANAGER_ROLE_LIST_SUCCESS,
  VAT_MANAGER_UPDATE,
  VAT_MANAGER_UPDATE_FAIL,
  VAT_MANAGER_UPDATE_RESET,
  VAT_MANAGER_UPDATE_SUCCESS,
} from "./actionTypes";

// List VATManager
export const listVATManager = (params = {}) => ({
  type: VAT_MANAGER_LIST,
  payload: { params },
});

export const listVATManagerSuccess = data => ({
  type: VAT_MANAGER_LIST_SUCCESS,
  payload: data,
});

export const listVATManagerFail = error => ({
  type: VAT_MANAGER_LIST_FAIL,
  payload: error,
});

export const resetListVATManager = () => ({
  type: VAT_MANAGER_LIST_RESET,
  payload: {},
});

export const setListVATManagerColumn = (field, value) => ({
  type: VAT_MANAGER_LIST_COLUMN,
  payload: { field, value },
});

// List VATManager Role
export const listVATManagerRole = (params = {}) => ({
  type: VAT_MANAGER_ROLE_LIST,
  payload: { params },
});

export const listVATManagerRoleSuccess = data => ({
  type: VAT_MANAGER_ROLE_LIST_SUCCESS,
  payload: data,
});

export const listVATManagerRoleFail = error => ({
  type: VAT_MANAGER_ROLE_LIST_FAIL,
  payload: error,
});

export const resetListVATManagerRole = () => ({
  type: VAT_MANAGER_ROLE_LIST_RESET,
  payload: {},
});

// Create VATManager
export const createVATManager = userCreate => ({
  type: VAT_MANAGER_CREATE,
  payload: { userCreate },
});

export const createVATManagerSuccess = data => ({
  type: VAT_MANAGER_CREATE_SUCCESS,
  payload: data,
});

export const createVATManagerFail = error => ({
  type: VAT_MANAGER_CREATE_FAIL,
  payload: error,
});

export const resetCreateVATManager = () => ({
  type: VAT_MANAGER_CREATE_RESET,
  payload: {},
});

// Detail VATManager
export const detailVATManager = (userId, params = {}) => ({
  type: VAT_MANAGER_DETAIL,
  payload: { userId, params },
});

export const detailVATManagerSuccess = data => ({
  type: VAT_MANAGER_DETAIL_SUCCESS,
  payload: data,
});

export const detailVATManagerFail = error => ({
  type: VAT_MANAGER_DETAIL_FAIL,
  payload: error,
});

export const resetDetailVATManager = () => ({
  type: VAT_MANAGER_DETAIL_RESET,
  payload: {},
});

// Update VATManager
export const updateVATManager = (userId, data = {}) => ({
  type: VAT_MANAGER_UPDATE,
  payload: { userId, data },
});

export const updateVATManagerSuccess = data => ({
  type: VAT_MANAGER_UPDATE_SUCCESS,
  payload: data,
});

export const updateVATManagerFail = error => ({
  type: VAT_MANAGER_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateVATManager = () => ({
  type: VAT_MANAGER_UPDATE_RESET,
  payload: {},
});

// Delete VATManager
export const deleteVATManager = userId => ({
  type: VAT_MANAGER_DELETE,
  payload: { userId },
});

export const deleteVATManagerSuccess = data => ({
  type: VAT_MANAGER_DELETE_SUCCESS,
  payload: data,
});

export const deleteVATManagerFail = error => ({
  type: VAT_MANAGER_DELETE_FAIL,
  payload: error,
});

export const resetDeleteVATManager = () => ({
  type: VAT_MANAGER_DELETE_RESET,
  payload: {},
});

// Active VATManager
export const activeVATManager = (userId, data = {}) => ({
  type: VAT_MANAGER_ACTIVE,
  payload: { userId, data },
});

export const activeVATManagerSuccess = data => ({
  type: VAT_MANAGER_ACTIVE_SUCCESS,
  payload: data,
});

export const activeVATManagerFail = error => ({
  type: VAT_MANAGER_ACTIVE_FAIL,
  payload: error,
});

export const resetActiveVATManager = () => ({
  type: VAT_MANAGER_ACTIVE_RESET,
  payload: {},
});
